import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { UserRole } from "__generated__/graphql";
import { RootState } from "redux/store";

export type PermissionActionValue =
  | "user_management:view"
  | "user_management:edit"
  | "rice_inspection:view"
  | "rice_inspection:create"
  | "rice_inspection:edit"
  | "rice_inspection:delete"
  | "rice_inspection:approve"
  | "rice_inspection:share"
  | "rice_inspection:view_all_user"
  | "rice_inspection:option.auto_yellow"
  | "rice_inspection:option.average_length"
  | "rice_inspection.setting:view"
  | "rice_inspection.setting:standard.edit"
  | "rice_inspection.setting:share"
  | "rice_inspection.setting:inspection.edit"
  | "social:line"
  | "notification:view"
  | "dashboard:view";

export type PermissionFeatureValue =
  | "user_management"
  | "rice_inspection"
  | "rice_inspection.setting"
  | "social"
  | "notification"
  | "web"
  | "dashboard"
  | "MFA"
  | "whiteness";

export type Role = {
  roleId: string;
  roleName: string;
  permission: PermissionValue;
  isAdmin: boolean;
};
export type Roles = Role[];

export type PermissionValue = {
  action: PermissionActionValue[];
  feature: PermissionFeatureValue[];
};

type IPermissionState = {
  isLoading: false;
} & Role;

const initialState: IPermissionState = {
  roleId: undefined,
  roleName: undefined,
  permission: undefined,
  isAdmin: false,
  isLoading: false,
};

const slice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermission(state, action) {
      const { roleId, roleName, permission, isAdmin } = action.payload;
      state.roleId = roleId;
      state.roleName = roleName;
      state.isAdmin = isAdmin;
      state.permission = permission;
    },
  },
});

export default slice.reducer;

export const setPermission = (result: UserRole) => {
  return async (dispatch: Dispatch) => {
    dispatch(
      slice.actions.setPermission({
        ...result,
        roleId: result.id,
        roleName: result.roleName,
        isAdmin: result.isAdmin,
        permission: result.permission,
      })
    );
  };
};

export const selectIsViewUserManagement = (state: RootState) => {
  return true;
};

export const selectRole = (state: RootState) => {
  return state.account.role.roleName;
};

export const selectPermissionFeature = (state: RootState) => (feature: PermissionFeatureValue) => {
  if (!state.account.role.permission) return false;
  const hasFeature = state.account.role.permission.feature.includes(feature);
  return hasFeature;
};

export const selectPermissionAction = (state: RootState) => (action: PermissionActionValue) => {
  if (!state.account.role.permission) return false;
  const hasAction = state.account.role.permission.action.includes(action);
  const hasFeature = state.account.role.permission.feature.includes(
    action.split(":")[0] as PermissionFeatureValue
  );
  return hasAction && hasFeature;
};
